<template>
  <div class="nav-tab" :style="{width:'calc(100% - '+width+'px)'}">

    <div class="action-btn action-sall-btn">
      <div class="action-child"><i class="icon el-icon-arrow-down"></i></div>
      <div class="tab-actions">
        <TabActions/>
      </div>
    </div>
    <div ref="navBox" class="nav-box">
      <div v-show="showPos" class="action-btn action-left-btn" @click="handelPrev">
        <div class="action-child"><i class="icon el-icon-arrow-left"></i></div>
      </div>
      <div v-show="showPos" class="action-btn action-right-btn" @click="handelNext">
        <div class="action-child"><i class="icon el-icon-arrow-right"></i></div>
      </div>
      <div 
        ref="navList"
        class="nav-list"
        :style="showPos?`left: 32px; transform: translateX(${slateX}px);`:`transform: translateX(${slateX}px);`"
      >
        <div 
          class="item" 
          @click="handleClick(item)" 
          :key="item.id" 
          :class="{'item-active': item.id == tabActiveMenu.id}" v-for="(item) in tabList"
          :style="tabList.length < 2 ? 'padding-right: 16px':''"
        >
          <div class="item-wrap">
            <span class="name">{{item.title}}</span>
            <i v-if="tabList.length > 1" @click.stop="handleRemove(item)" class="icon el-icon-close"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TabActions from './components/tabActions'
  export default {
    components: {
      TabActions
    },
    props: {
      width: {
        type: Number,
        default: () => 0
      }
    },
    data() {
      return {
        slateX: 0,
        showPos: false,
        navNum: 1,
        ww: 0,
        sw: 0
      }
    },
    computed: {
      ...mapState({
        tabList: state => state.app.tabList,
        tabActiveMenu: state => state.app.tabActiveMenu,
      })
    },
    watch: {
      tabList(n) {
        if (n.length != this.navNum) {
          setTimeout(() => {
            this.setBar()
          })
        } else {
          setTimeout(() => {
            this.setBar()
          })
        }
        this.navNum = n.length
      }
    },
    mounted() {
      
      window.addEventListener('resize', () => {
        this.setBar()
      })
    },
    methods: {
      ...mapActions('app', [
        'removeTabList'
      ]),
      handelPrev() {
        let x = this.slateX + 102
        if (Math.abs(x) <= 102) {
          x = 0
        }
        this.slateX = x
      },
      handelNext() {
        let x = this.slateX - 102
        if (Math.abs(x) >= (this.sw - this.ww)) {
          x = -(this.sw - this.ww)
        }
        this.slateX = x
      },
      setCurrentPos(ww, sw) {
        !ww && (ww = this.ww)
        !sw && (sw = this.sw)
        this.ww = ww
        this.sw = sw
        let left = 0
        if (this.showPos) {
          let index = this.tabList.map(obj => obj.id).indexOf(this.tabActiveMenu.id)
          let x = (index + 1) * 102
          left = x - (ww/2 - 51)
          if (left >= 0) {
            if (sw <= (ww + left)) {
              left = sw - ww
            }
          } else {
            left = 0
          }
          this.slateX = -left
        } else {
          this.slateX = 0
        }
      },
      setBar() {
        if (!this.$refs.navBox) return
        let max = this.$refs.navBox.offsetWidth - 96
        let w = this.$refs.navList.offsetWidth
        if (w >= max) {
          this.showPos = true
        } else {
          this.showPos = false
        }
        this.setCurrentPos(max, w)
      },
      handleClick(item) {
        if (item.fullPath != this.$route.fullPath) {
          this.$router.push(item.fullPath)
        }
      },
      handleRemove(item) {
        this.removeTabList({
          id: item.id,
          cb: (current) => {
            if (current.fullPath != this.$route.fullPath) {
              this.$router.push(current.fullPath)
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.nav-tab {
  position: fixed;
  top: 64px;
  height: 44px;
  right: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  z-index:4;
  background: #f5f7f9;
  .nav-box {
    margin: 0 12px;
    flex: 1;
    height: 32px;
    position: relative;
    overflow: hidden;
  }
  .nav-list {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    font-size: 0;
    color: #333;
    white-space: nowrap;
    transition: all .3s;
    transform: translateX(0px);
    .item {
      cursor: pointer;
      // height: 32px;
      padding: 0 8px 0 16px;
      // transition: all .3s ease-in-out;
      font-size: 14px;
      display: inline-block;
      margin-right: 6px;
      color: #808695;
      background: #fff;
      border-radius: 4px;
      height: 100%;
      .name {
        vertical-align: middle;
        user-select: none;
      }
      &:hover {
        color: #333;
      }
      .icon {
        color: #808695;
        &:hover {
          color: #333;
        }
      }
      &:last-child {
        margin: 0;
      }
    }
    .item-wrap {
      height: 100%;
      display: flex;
      align-items: center;
      
    }
    .item-active {
      color: #2d8cf0;
      &:hover {
        color: #2d8cf0;
      }
    }
  }
  .action-btn {
    width: 32px;
    height: 32px;
    z-index: 1;
    background: #f5f7f9;
    position: absolute;
    .action-child {
      background: #fff;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 100%;
      height: 100%;
    }
  }
  .action-sall-btn {
    top: 6px;
    right: 12px;
    .tab-actions {
      position: absolute;
      right: 0;
      right: 0;
      bottom: 0;
      transform: translateY(100%);
      display: none;
      width: 120px;
    }
    &:hover {
      .tab-actions {
        display: block;
      }
    }
  }
  .action-left-btn {
    top: 0;
    left: 0;
    .action-child {
      background: none;
    }
  }
  .action-right-btn {
    top: 0;
    right: 32px;
    .action-child {
      background: none;
    }
  }
}
</style>